export default __webpack_public_path__ + "static/media/dog1.960ad6ae.png";